import React from "react";
import { FederatedApp } from "@dtsl/react-utils";
import { federatedAppData } from "../common";

const CommonNavImpl = () => {
    const env = ENVIRONMENT;
    const navigationProps={
        env,
        isAppMFE: false,
        isNavExpanded: false,
        highlightedRoutes: {}
    }
    const navigationData=federatedAppData[env]["commonNavigation"];

    return (
        <div className='brevo-left-container'>
            <FederatedApp
                appData={navigationData} 
                appProps={navigationProps} 
                fallback={<></>}
            />
        </div>
    )
}

export default CommonNavImpl;